<template>
  <div class="content_body" id="restobody">
    <div class="body">
      <div class="categories">
        <!-- <div class="left_arrow">
          <i class="feather-chevron-left"></i>
        </div> -->


        <div class="category_items">
          <div class="category_item" @click="showLangueChange">
            <!--<img src="htttp://localhost:3333/new_images/filter.png" class="filrer_category" alt="" srcset="" @click="showLangueChange">-->
            <img src="../../../public/illustrations/languages.png" class="filrer_category" alt="" srcset=""  >
            <!--<span style="position:absolute;color:white;text-transform: uppercase;">FR</span>-->
          </div>
          <template v-for="(section, index) in listSections">
            <div :key="`${index}_sections_menu`" v-if="index == currentTab" class="category_item active"
              @click="selected = index">
              <div>
                {{ section.title }}
              </div>
            </div>
            <div :key="`${index}_sections_menu`" @click="selected = index" v-else class="category_item">
              <div>
                {{ section.title }} 
              </div>
            </div>
          </template>

          <div class="category_space">
            <div></div>
          </div>
        </div>

        <!-- <div class="right_arrow">
          <i class="feather-chevron-right"></i>
        </div> -->
      </div>
      <div class="category">
        <!-- <img :src="`${apiPath1}/category.png`" class="category_img" alt="" /> -->
        <h3>
          {{ listSections[selected].title }}
        </h3>
      </div>
      <div class="items">
        <template v-for="(subSection, indexSubCategorie) in listSections[selected]
        .sub_sections">
          <!-- <div
            :key="`${indexSubCategorie}_sub_categories`"
            @click="
              sub_selected = indexSubCategorie;
              collapsedArray(indexSubCategorie, selected);
            "
            class="subsection subsection-dispal"
            v-if="showSub(subSection)"
          >
            <span>{{
              subSection.title == "null-sub-sections" ? "" : subSection.title
            }}</span>
            <div class="sub_category_options">
              <img
                :src="`${apiPath1}/icons/caret-down.png`"
                class="down"
                alt=""
              />
            </div>
          </div> -->
          <template v-if="
            showSub(subSection) && (vIfcollapsed(indexSubCategorie, selected) || 1 == 1)
          ">
            <div v-for="(item, indiceItem) in subSection.items" :key="`${indexSubCategorie}_${indiceItem}_mwnu_items`"
              :class="`item my_item_ ${item.disponible?'':'out_stock'}`" :ref="`item_${indexSubCategorie}_${indiceItem}`" @click.stop="
                (e) => {
                  if(item.disponible){
                    triggeraddToCart(item, e);
                  }
                  
                }
              ">
              <div class="item_content">
                <div class="item_left">
                  <div class="item_infos">
                    <h4 class="calculated_price">
                      <span>{{ item.title }}</span>
                    </h4>
                    <p>
                      {{ item.observation?.length > 50 ? `${item.observation.substring(0, 50)}...` : item.observation }}
                    </p>
                    <span class="article_price">{{ getPrice(item.price) }}{{ currentCurrency.symbol }}</span>
                  </div>
                  <img :src="
                    `htttp://localhost:3333/${item.image ? 'uploads/menus-items/' + item.image : 'logos/logo.png'}`
                  " alt="" class="img_article" />
                </div>
                
              </div>
              
              <div class="item_tags">
                <img :src="`htttp://localhost:3333/uploads/tags/${tag.image}`" :alt="`${tag.title}`" class="item_tag" v-for="tag in item.tags" :key="tag._id">
              </div>
              <div class="_item_devider"></div>
              <!-- <div class="fact_item_controls">
                <div class="plus_controle" @click.stop="TriggerAddQuanity(item,`item_${indexSubCategorie}_${indiceItem}`)"><span>+</span></div>
              </div>-->
              <!-- <div class="quantity_controle"><span>{{ quantities[item.objectNumber]?quantities[item.objectNumber]:0 }}</span></div>
                <div class="minus_controle" @click.stop="TriggerSubstractQuanity(item)"><span>-</span></div> -->

            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
// import { apiPath1 } from "../../constants/config";
export default {
  props: [
    "reserved_items",
    "indexes",
    "quantities",
    "newItem",
    "newSection",
    "listSections",
    "changeSectionTitle",
    "changeSectionSubTitle",
    "setCurrentTab",
    "currentTab",
    "addItem",
    "newSubSection",
    "handleChangeShowSub",
    "disponibleItem",
    "showItem",
    "changeItemObservation",
    "changeItemPrice",
    "changeItemTitle",
    "editCategorie",
    "deleteSection",
    "editSubCategorie",
    "deleteSubSection",
    "editItem",
    "deleteItem",
    "currentCurrency",
    "addToCart",
    "SubstractQuanity",
    "RemoveItem",
    "AddQuanity",
  ],
  data() {
    return {
      apiPath1: "htttp://localhost:3333",
      selected: 0,
      sub_selected: 0,
      collapsedArrayVar: ["0_0", "0_1"],
    };
  },
  computed: {

  },
  watch: {
    selected(newval) {
      // if(newVal!=this.currentTab){
      this.setCurrentTab(newval);
      // }
    },
    currentTab(newVal) {
      if (newVal != this.selected) {
        this.selected = newVal;
      }
    },
  },
  methods: {
    showLangueChange(){
      this.$modal.show("langueChange")
    },
    getPrice(price) {
      return parseFloat(price * 1).toFixed(2)
    },
    triggeraddToCart(item, e) {
      console.log(item, e);

      this.addToCart(item, e)
    },
    TriggerAddQuanity(item, ref) {
      if (this.quantities[item.objectNumber] !== undefined) {
        this.AddQuanity(this.indexes[item.objectNumber])
      } else {
        //  const elem = this.$refs[ref]
        //       elem[0].click()
        this.addToCart(item, null)
      }
    },
    TriggerSubstractQuanity(item) {
      if (this.quantities[item.objectNumber] !== undefined) {
        this.SubstractQuanity(this.indexes[item.objectNumber])
      } else {

      }
    },
    vIfcollapsed(indexSubCategorie, indexSection) {
      let searchedIndice = indexSection + "_" + indexSubCategorie;
      let item = this.collapsedArrayVar.find((item) => item == searchedIndice);
      if (item) {
        return true;
      } else {
        return false;
      }
    },
    collapsedArray(indexSubCategorie, indexSection) {
      let searchedIndice = indexSection + "_" + indexSubCategorie;

      if (this.collapsedArrayVar.includes(searchedIndice)) {
        this.collapsedArrayVar.splice(
          this.collapsedArrayVar.indexOf(searchedIndice),
          1
        );
      } else {
        this.collapsedArrayVar.push(searchedIndice);
      }
    },
    collapsed(index, selected) {
      this.functionCollapsed(index, selected);
      // this.$emit("functionCollapsed", index, selected);
    },
    deleteCategorie() {
      let old_selected = this.selected;
      if (this.selected != 0) {
        this.selected = this.selected - 1;
      }
      this.deleteSection(old_selected);
    },
    showSub(subSection) {
      // console.log(this.newItem[0].sections);
      // console.log(subSection);
      console.log(this.listSections[this.selected].show_subCategories);
      if (this.listSections[this.selected].show_subCategories == undefined) {
        return true;
      }
      if (
        this.newItem[0].sections[this.selected].show_subCategories &&
        !subSection.defaultNonSub
      ) {
        return true;
      } else if (
        !this.newItem[0].sections[this.selected].show_subCategories &&
        subSection.defaultNonSub
      ) {
        return true;
      }
      return true;
    },
  },
};
</script>
<style>
@import url("../styles/monresto-body.scss");

.subsection-dispal {
  display: flex !important;
}

#restobody .items {
  width: unset !important;
}

.item_infos p {
  text-align: left;
}

.img_article {
  object-fit: contain;
}

.my_item_{
  flex-wrap: wrap;
}
.item_left {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.item_infos {
  padding-left: 4%;
}

.item_infos h4,
p,
span {
  margin: 5px 0;
}
.item_tags{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  gap:24px;
  padding-top: 6px;
  padding-bottom: 12px;
}
.item_tag{
  width: 22px;
  object-fit: contain;
}
._item_devider{
  height: .5px;
  width: 90%;
  margin: auto;
  background: gray;
}

.item.my_item_.out_stock h4 ,.item.my_item_.out_stock span,.item.my_item_.out_stock p{
   text-decoration: line-through !important;
}
.item.my_item_.out_stock{
  opacity: .6 !important;
}
</style>
